import { useEffect, useState } from "react";
import CSBoard from "../../../components/csboard/CSBoard-Layout";
import styled from "styled-components";
import { downloadsAPI } from "../../../api/downloads";
import { Spinner } from "react-bootstrap";
import { successAlert } from "@common/alert";

const DownloadWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const DownloadRow = styled.div`
  margin: auto 0;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-column-gap: 20px;
  grid-row-gap: 20px;
  @media (max-width: 1200px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media (max-width: 767px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 575px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

const DownloadBox = styled.a`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 2px solid #ececec;
  padding: 20px 10px;
  min-height: 150px;
  cursor: pointer;
  .icon {
    width: 70%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 64px;
    margin-bottom: 20px;
    color: gray;
  }

  :hover {
    .icon {
      color: #3bb77e;
    }
    border: 2px solid #3bb77e;
  }
`;

const CSBoardLibraryPage = () => {
  const [introductions, setIntroductions] = useState([]); // 전체
  const [b2bProposals, setB2bProposals] = useState([]); //포트폴리오&B2B제안서
  const [productIntroductions, setProductIntroductions] = useState([]); //포장제품소개서
  const [downLoading, setDownLoading] = useState(false);

  const fetchIntroductions = async () => {
    const body = {
      modes: "ListSet",
    };
    const res = await downloadsAPI(body);
    if (res.Code === "0000") {
      const allIntroductions = res?.Data?.Data?.introduction || [];
      setIntroductions(allIntroductions);

      // B2B 제안서 및 포트폴리오 (F5999, F4948)
      const b2bItems = allIntroductions.filter(
        (item) => item.code === "F5999" || item.code === "F4948" || item.code === "F2412"
      );
      setB2bProposals(b2bItems);

      // 포장 제품 소개서 (나머지 코드)
      const productItems = allIntroductions.filter(
        (item) => item.code !== "F5999" && item.code !== "F4948" && item.code !== "F2412"
      );
      setProductIntroductions(productItems);

      setDownLoading(false);
    } else {
      setIntroductions([]);
      setB2bProposals([]);
      setProductIntroductions([]);
      console.error(res.Data?.Msg);
      setDownLoading(false);
    }
  };

  const downloadImgs = {
    F5999:
      "https://file.caretbio.com/caretbio/34fe3d6a4b4f60dd683eb8f064b80380.png",
    F4948:
      "https://file.caretbio.com/caretbio/392cd45612edf5d35b177ae0621dc45f.png",
    F9049:
      "https://file.caretbio.com/caretbio/제품소개서_리펄프패키징_240325173331.png",
    F2172:
      "https://file.caretbio.com/caretbio/제품소개서_에코날개박스.png",
    F3385:
      "https://file.caretbio.com/caretbio/제품소개서_칼렛에어.png",
    F1554:
      "https://file.caretbio.com/caretbio/제품소개서_농산물포장.png",
    F7858:
      "https://file.caretbio.com/caretbio/제품소개서_종이보냉박스.png",
    F9810:
      "https://file.caretbio.com/caretbio/제품소개서_펄프용기.png",
    F0488:
      "https://file.caretbio.com/caretbio/제품소개서_칼라박스.png",
    F2313:
      "https://file.caretbio.com/caretbio/제품소개서_리펄프테이프.png",
    F6151:
      "https://file.caretbio.com/caretbio/제품소개서_비닐포장재.png",
    F5177:
      "https://file.caretbio.com/caretbio/제픔소개서_EL727 비닐포장재.png",
    F2717:
      "https://file.caretbio.com/caretbio/제품소개서_친환경PCM보냉팩.png",
    F2412:
      "https://file.caretbio.com/caretbio/392cd45612edf5d35b177ae0621dc45f.png",
    F5193:
      "https://file.caretbio.com/caretbio/fe5906f5b8f42c1b7ca9546d956ac9bc.png",      
  };

  useEffect(() => {
    setDownLoading(true);
    fetchIntroductions();
  }, []);

  return (
    <CSBoard>
      <div className="pb-30 d-flex align-items-center justify-content-between">
        <h1
          style={{
            borderBottom: "2px solid black",
            width: "100%",
          }}
        >
          자료 다운로드
        </h1>
        {/* 공유 */}
        <a
          aria-label="Share"
          className="action-btn hover-up"
          onClick={() =>
            navigator.clipboard
              .writeText(globalThis.location.href)
              .then(() => successAlert("복사되었습니다."))
          }
        >
          <i
            className="fi-rs-share"
            style={{
              fontSize: "20px",
            }}
          ></i>
        </a>
      </div>

      {downLoading ? (
        <div className="d-flex justify-content-center align-items-center h-50">
          <Spinner />
        </div>
      ) : (
        <>
          {/*  B2B제안서 및 포트폴리오 */}
          <h3 className="mt-30 mb-30">비즈니스 자료실</h3>
          <DownloadWrapper>
            <DownloadRow>
              {b2bProposals &&
                b2bProposals.map((el, i) => (
                  <DownloadBox
                    key={i}
                    className="box"
                    href={el.url}
                    target="_blank"
                    download={`${el.name}.pdf`}
                  >
                    <div className="icon">
                      <img
                        src={downloadImgs[el.code]}
                        alt={downloadImgs[el.code]?.split("/")[4]}
                      />
                    </div>
                    <h6 className="title">{el.name}</h6>
                  </DownloadBox>
                ))}
            </DownloadRow>
          </DownloadWrapper>

          {/* 포장 제품 소개서 */}
          <h3 className="mt-30 mb-30">포장 제품 소개서</h3>
          <DownloadWrapper>
            <DownloadRow>
              {productIntroductions &&
                productIntroductions.map((el, i) => (
                  <DownloadBox
                    key={i}
                    className="box"
                    href={el.url}
                    target="_blank"
                    download={`${el.name}.pdf`}
                  >
                    <div className="icon">
                      <img
                        src={downloadImgs[el.code]}
                        alt={downloadImgs[el.code]?.split("/")[4]}
                      />
                    </div>
                    <h6 className="title">{el.name}</h6>
                  </DownloadBox>
                ))}
            </DownloadRow>
          </DownloadWrapper>
        </>
      )}
    </CSBoard>
  );
};
export default CSBoardLibraryPage;
